import React from "react";
import { User, Shield, Briefcase, CheckCircle } from "lucide-react";

interface WizardStepIndicatorProps {
  currentStep: number; // 0-indexed
  steps: { label: string; icon: React.FC<any>; optional?: boolean }[];
}

const WizardStepIndicator: React.FC<WizardStepIndicatorProps> = ({ currentStep, steps }) => {
  return (
    <div className="flex items-center justify-between px-2">
      {steps.map((step, i) => {
        const Icon = step.icon;
        const isCompleted = i < currentStep;
        const isCurrent = i === currentStep;
        const isUpcoming = i > currentStep;

        return (
          <React.Fragment key={i}>
            {/* Step circle */}
            <div className="flex flex-col items-center gap-1.5">
              <div
                className={`h-9 w-9 rounded-full flex items-center justify-center transition-all ${
                  isCompleted
                    ? "bg-brand-accent text-white"
                    : isCurrent
                    ? "bg-brand-light text-brand ring-2 ring-brand-accent"
                    : "bg-slate-100 text-slate-400"
                }`}
              >
                {isCompleted ? (
                  <CheckCircle className="h-5 w-5" />
                ) : (
                  <Icon className="h-4.5 w-4.5" />
                )}
              </div>
              <span
                className={`text-xs font-medium ${
                  isCurrent ? "text-brand" : isCompleted ? "text-brand-accent" : "text-slate-400"
                }`}
              >
                {step.label}
              </span>
              {step.optional && (
                <span className={`text-[10px] font-normal ${
                  isCurrent ? "text-brand-accent/70" : isCompleted ? "text-brand-accent/60" : "text-slate-300"
                }`}>
                  Optional
                </span>
              )}
            </div>

            {/* Connector line */}
            {i < steps.length - 1 && (
              <div className="flex-1 mx-3 mb-5">
                <div
                  className={`h-0.5 w-full rounded ${
                    i < currentStep ? "bg-brand-accent" : "bg-slate-200"
                  }`}
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default WizardStepIndicator;
